import MouseMode from "../settings/MouseMode";
import PortalContext from "../../PortalContext";
import {LineAnnotation, Point, Rectangle} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import MouseFunction from "../settings/MouseFunction";
import Immutable from "../../../shared/immutable/Immutable";
import {I18nGlobals} from "../../../shared/translation/i18nInterface";
import {PortalToolboxAnnotationAnnotation} from "../../../shared/models/PortalToolboxAnnotationAnnotation";
import UserSettings from "../../session/UserSettings";
import {DebugGlobals} from "../../dialog/components/settings/DebugDialog";

export class PortalOperationPoint extends Point {
	page: number;
	timestamp: number;

	constructor(data: any) {
		super(data);

		this.page = data.page;
		this.timestamp = data.timestamp;
	}
}

export class PortalOperationRectangle extends Rectangle {
	page: number;
	timestamp: number;

	constructor(data: any) {
		super(data);

		this.page = data.page;
		this.timestamp = data.timestamp;
	}
}

export class PortalOperationLineAnnotation extends LineAnnotation {
	page: number;
	timestamp: number;

	constructor(data: any) {
		super(data);

		this.page = data.page;
		this.timestamp = data.timestamp;
	}
}

export interface AreaLayerGlobals {
	mouseFunctionPoint: Immutable<PortalOperationPoint> | null;
	mouseFunctionRect: Immutable<PortalOperationRectangle> | null;
	mouseFunctionLine: Immutable<PortalOperationLineAnnotation> | null;
	mouseFunctionAnnotationParameter: Immutable<PortalToolboxAnnotationAnnotation> | null;
	applyMouseFunction: boolean;
}

export function initAreaLayerGlobals(): AreaLayerGlobals {
	return {
		mouseFunctionRect: null,
		mouseFunctionPoint: null,
		mouseFunctionLine: null,
		mouseFunctionAnnotationParameter: null,
		applyMouseFunction: false
	};
}

export interface AreaLayerProperties extends AreaLayerGlobals, I18nGlobals, DebugGlobals {
	context: PortalContext;
	mouseMode: MouseMode;
	mouseFunction: MouseFunction;
	zoomValue: number;
	pageNumber: number;
	attachmentKey?: string;
	handleInteractivity?: () => void;
	interactivePage?: number;
	userSettings: Immutable<UserSettings>;
}